export enum MagazineView {
    MagazineHome = "MagazineHome",
    CurrentMagazine = "CurrentMagazine",
    PastMagazine = "PastMagazine",
    MagazinebyMonthandYear = "MagazinebyMonthandYear"
  }
  